"use client";

import { useCarousel } from "@/shared/hooks/useCarousel";
import { ProgressBar } from "../../../shared/ui/ProgressBar/ProgressBar";
import { IOtherProjects } from "../types";
import leftArrow from "@/shared/images/arrow_l_mini.webp";
import rightArrow from "@/shared/images/arrow_r_mini.webp";
import Image from "next/image";
import Link from "next/link";
import "./OtherProjects.css";

const OtherProjectsClient: React.FC<IOtherProjects> = ({
  content,
  staticText,
}) => {
  const config = {
    scrollStep: 1,
    threshold: 0.85,
    isVisible: true,
    initialIndex: 0,
    centerOffsetX: 0,
  };

  const {
    rootRef,
    itemsRef,
    currentIndex,
    swipeHandlers,
    handleKeyPress,
    handleScrollLeft,
    handleScrollRight,
    handleWheel,
  } = useCarousel({ content, config });

  return (
    <section className={"carousel-other"} {...swipeHandlers}>
      <div className="carousel-other__wrapper">
        <h3 className={"carousel-other__title"}>{staticText}</h3>
        <div
          className={"carousel-other__slides"}
          ref={rootRef}
          onKeyDown={handleKeyPress}
          onWheel={handleWheel}
        >
          {content.map((item, index: number) => (
            <Link
              className={"carousel-other__slide"}
              key={index}
              href={`/portfolio/` + item.slug}
              ref={(node) => {
                if (node) {
                  itemsRef.current.set(index, node);
                } else {
                  itemsRef.current.delete(index);
                }
              }}
            >
              <div className={"carousel-other__imgWrapper"}>
                <Image
                  width={700}
                  height={700}
                  className={"carousel-other__img"}
                  src={item.imgUrl}
                  alt="slide img"
                  loading="lazy"
                />
              </div>
              <div className={"carousel-other__descriptionContainer"}>
                <h6 className={"carousel-other__descriptionTitle"}>
                  {item.title}
                </h6>
                <span className={"carousel-other__description"}>
                  {item.subtitle}
                </span>
              </div>
            </Link>
          ))}
        </div>
        <div className={"carousel-other__bottomWrapper"}>
          <div className={"carousel-other__controls"}>
            <Image
              height={14}
              width={7.8}
              src={leftArrow}
              onClick={handleScrollLeft}
              className={"carousel-other__arrow"}
              alt="arrow"
            />
            <Image
              height={14}
              width={7.8}
              src={rightArrow}
              onClick={handleScrollRight}
              className={"carousel-other__arrow"}
              alt="arrow"
            />
          </div>
          <ProgressBar length={content.length} index={currentIndex} />
        </div>
      </div>
    </section>
  );
};

export default OtherProjectsClient;
